module.exports = __webpack_public_path__ + "static/photo1-1779d799f0fd97b17c0ee370d2599daa.jpg";